import { fetchRequest } from './';
import { CoderNote, WorksheetId } from './domain';
import { worksheetMessage, WorksheetResult } from './worksheet-service';


const service = 'codernotes';

export type NoteResult = WorksheetResult<CoderNote>;
export type NoteListResult = WorksheetResult<CoderNote[]>;

interface NoteArgs extends WorksheetId {
  note: string;
}

export const addCoderNoteRequest = fetchRequest<NoteArgs, NoteResult>({
  method: 'post',
  body: (args: NoteArgs) => worksheetMessage(args, 'addcodernote', service),
});

interface NoteActionArgs extends WorksheetId {
  coderNoteId: string;
}
export type NoteActionResult = WorksheetResult<NoteActionArgs>;

export const deleteCoderNoteteRequest = fetchRequest<
  NoteActionArgs,
  NoteActionResult
>({
  method: 'post',
  body: (args: NoteActionArgs) =>
    worksheetMessage(args, 'deletecodernote', service),
});

export const acknowledgeCoderNoteteRequest = fetchRequest<
  NoteActionArgs,
  NoteActionResult
>({
  method: 'post',
  body: (args: NoteActionArgs) =>
    worksheetMessage(args, 'acknowledgecodernote', service),
});

export const getCoderNotesRequest = fetchRequest<WorksheetId, NoteListResult>({
  method: 'post',
  body: (args: WorksheetId) => worksheetMessage(args, 'getcodernotes', service),
});


interface StickyArgs {
  code: string;
  note?: string;
  workflow?: string;
}



export const addStickyNoteRequest = fetchRequest<StickyArgs, NoteResult>({
  method: 'post',
  body: (args: StickyArgs) =>
    worksheetMessage(args, 'addstickynote', 'worksheet'),
});

export async function addStickyNote(args: StickyArgs, item: any) {
  const r = await addStickyNoteRequest(args);
  if (r.success) {
    item.note = r.result;
  } else {
    item.note = args;
  }
  item.stickyNote = item.note;
}

export const deleteStickyNoteRequest = fetchRequest<StickyArgs, NoteResult>({
  method: 'post',
  body: (args: StickyArgs) =>
    worksheetMessage(args, 'deletestickynote', 'worksheet'),
});


export async function removeStickyNote(item: any) {
  item.stickyNote = null;
  item.note = null;
  await deleteStickyNoteRequest({
    code: item.cptCode || item.diagnosisCode || item.code,
  });
}
